export const GenerateCode = ({ name, code, formik }) => {
    try {
        const randomNumber = Math.floor(Math.random() * 100000);
        const currentYear = new Date().getFullYear();
        const productName = name?.replace(/\s+/g, '-')?.toUpperCase();
        const initials = productName?.split('-').map((word) => word.charAt(0)).join('');
        const productCode = `${initials}-${randomNumber}-${currentYear}`;
        return formik.setFieldValue(code, productCode);
    } catch (error) {
        return null
    }
};